import api from '../configs/api.config';
import {
  ClientCreditSummary,
  CustomersWithCreditBalanceResponse,
  CreditSpendHistoryResponse,
  CreditSpendHistoryParams,
  AddCreditRequest,
  AddCreditResponse,
  VoidCreditResponse
} from '../types/credit.types';

export const getClientCreditSummary = async (clientId: string): Promise<ClientCreditSummary> => {
  const { data } = await api.get<ClientCreditSummary>(`/Credit/client/${clientId}`);
  return data;
};

export const getCustomersWithCreditBalance =
  async (): Promise<CustomersWithCreditBalanceResponse> => {
    const { data } = await api.get<CustomersWithCreditBalanceResponse>(
      '/Credit/customers-with-balance'
    );
    return data;
  };

export const getCreditSpendHistory = async (
  params: CreditSpendHistoryParams = {}
): Promise<CreditSpendHistoryResponse> => {
  const queryParams: Record<string, string | number> = {};

  if (params.page) queryParams['page'] = params.page;
  if (params.pageSize) queryParams['page-size'] = params.pageSize;
  if (params.clientId) queryParams['client-id'] = params.clientId;

  const { data } = await api.get<CreditSpendHistoryResponse>('/Credit/spend-history', {
    params: queryParams
  });
  return data;
};

export const addCredit = async (request: AddCreditRequest): Promise<AddCreditResponse> => {
  const { data } = await api.post<AddCreditResponse>('/Credit', request);
  return data;
};

export const voidCredit = async (creditId: string): Promise<VoidCreditResponse> => {
  const { data } = await api.delete<VoidCreditResponse>(`/Credit/${creditId}`);
  return data;
};
